import {
  GET_UPLOAD_IMAGE,
  UPDATE_UPLOAD_IMAGE,
  REMOVE_UPLOADED_IMAGE,
  REMOVE_UPLOAD_IMAGE_BACKGROUND,
  UPDATE_IMAGE_LOADING,
  UPDATE_UPLOAD_IMAGE_ERROR_INFO,
  REMOVE_IMAGE_LOADING,
  REMOVE_UPLOAD_IMAGE_ERROR_INFO,
  UPDATE_UPLOAD_IMAGE_LOCKED_INFO,
  UPDATE__IMAGE_SIZE,
  UPDATE__IMAGE_PLACEMENT,
  REMOVE_LINE_ITEM_S3,
  UPDATE_URL_FOR_UPLOAD_IMAGES,
  UPDATE_PREV_LOGO_TO_NEW_LINEITEMID,
  UPDATE_URL_FOR_UPLOAD_IMAGES_ON_ATB,
  GET_COLOR_LOGO,
  UPDATE_LOGO_TAB,
  SAVE_UPDATED_LOGO_COLOR_COUNT,
  UPDATE_LOGO_COLOR_COUNT,
  SHOW_UPLOAD_IMAGE_ERROR,
  UPDATE_COPY_LOGO
} from './actionTypes';

export const getUploadImages = (payload) => ({
  type: GET_UPLOAD_IMAGE,
  payload,
});

export const updateUploadImage = (payload) => ({
  type: UPDATE_UPLOAD_IMAGE,
  payload,
});

export const removeUploadedImage = (payload) => ({
  type: REMOVE_UPLOADED_IMAGE,
  payload,
});

export const removeLineItemFromS3 = (payload) => ({
  type: REMOVE_LINE_ITEM_S3,
  payload,
});

export const removeUploadImageBackground = (payload) => ({
  type: REMOVE_UPLOAD_IMAGE_BACKGROUND,
  payload,
});

export const updateImageLoading = (payload) => ({
  type: UPDATE_IMAGE_LOADING,
  payload,
});

export const updateImageSize = (payload) => ({
  type: UPDATE__IMAGE_SIZE,
  payload,
});

export const updateImagePlacement = (payload) => ({
  type: UPDATE__IMAGE_PLACEMENT,
  payload,
});

export const updateUploadImagesErrorInfo = (payload) => ({
  type: UPDATE_UPLOAD_IMAGE_ERROR_INFO,
  payload,
});
export const removeImageLoading = (payload) => ({
  type: REMOVE_IMAGE_LOADING,
  payload,
});

export const removeUploadImagesErrorInfo = (payload) => ({
  type: REMOVE_UPLOAD_IMAGE_ERROR_INFO,
  payload,
});

export const updateUploadImagesLockedInfo = (payload) => ({
  type: UPDATE_UPLOAD_IMAGE_LOCKED_INFO,
  payload,
});

export const updateUrlForUploadImages = (payload) => ({
  type: UPDATE_URL_FOR_UPLOAD_IMAGES,
  payload,
});

export const updatePrevLogoToNewLineItemId = (payload) => ({
  type: UPDATE_PREV_LOGO_TO_NEW_LINEITEMID,
  payload,
});

export const updateUrlForUploadImagesOnATB = (payload) => ({
  type: UPDATE_URL_FOR_UPLOAD_IMAGES_ON_ATB,
  payload,
});

export const updateColorLogo = (payload) => ({
  type: GET_COLOR_LOGO,
  payload,
});

export const updateLogoTab = (payload) => ({
  type: UPDATE_LOGO_TAB,
  payload,
});

export const updateLogoColorCount = (payload) => ({
  type: UPDATE_LOGO_COLOR_COUNT,
  payload,
});

export const saveUpdatedLogoColorCount = (payload) => ({
  type: SAVE_UPDATED_LOGO_COLOR_COUNT,
  payload,
});

export const showUploadImageError = (payload) => ({
  type: SHOW_UPLOAD_IMAGE_ERROR,
  payload,
});

export const updateCopyLogo = (payload) => ({
  type: UPDATE_COPY_LOGO,
  payload,
});
